import axiosClient from '../configs/axios.js';

class Vehicleloading {
  
    async getvehicleloadingList(params) {
        try {
            const response = await axiosClient.get(
                `/tempo_loading/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching  tempo list:', error);
            throw error;
        }
    }
  

    

async editDeletevehicleloading(data) {
        try {
            const response = await axiosClient.put(`/tempo_loading/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
export default new Vehicleloading();